import { render, staticRenderFns } from "./DrivewealthAccountSummaryView.vue?vue&type=template&id=568e10ce"
import script from "./DrivewealthAccountSummaryView.vue?vue&type=script&lang=ts"
export * from "./DrivewealthAccountSummaryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports